import React, { Component } from "react";

class Directory extends Component {
	render() {
		return (
			<section>
				<div
					id="top-content-region"
					className="top-content padding-top-15 padding-bottom-15 block-15 bg-color-grayLight1"
				>
					<div className="container">
						<div className="row">
							<div id="top-content-left-region" className="top-content-left col-xs-12 col-md-6 text-center-sm">
								<div id="page-title-block" className="page-title block">
									<h1>Directory</h1>
								</div>
							</div>

							<div
								id="top-content-right-region"
								className="top-content-right col-xs-12 col-md-6 text-right text-center-sm"
							>
								<div id="page-breadcrumbs-block" className="page-breadcrumbs block">
									<div className="breadcrumbs">
										<a href="/">Home</a>
										<span className="delimiter">›</span>
										<a href="/ContactUs">Contact Us</a>
										<span className="delimiter">›</span>
										<span title="" className="nolink">
											Directory
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="content-region">
					<div className="container">
						<div className="row">
							<div id="main-content-region" className="main-content col-xs-12">
								<div className="region region-content">
									<div id="block-system-main" className="block block-system">
										<div className="content">
											<div className="node node-page clearfix">
												<div className="content">
													<div className="row">
														<div className="col-md-4 col-sm-6 col-xs-12">
															<h4>Eldership</h4>
															Ettiene de Wilzem - Pastor
															<ul className="no-list-style">
																<li>0403 720 501</li>
																<li>
																	<a href="mailto:pastor@pathwaytolife.org.au">pastor@pathwaytolife.org.au</a>
																</li>
															</ul>
															Ryan Niebuur - Associate Pastor
															<ul className="no-list-style">
																<li>0418 601 533</li>
																<li>
																	<a href="mailto:rnbniebuur@gmail.com">rnbniebuur@gmail.com</a>
																</li>
															</ul>
															Rob Groenewold - Chair
															<ul className="no-list-style">
																<li>0417 302 869</li>
																<li>
																	<a href="mailto:rdgroenewold@gmail.com">rdgroenewold@gmail.com</a>
																</li>
															</ul>
															Mark de Jonge
															<br />
															Andy Carden
																<br />
															Etienne de Kock
																<br />
															Vernon Zamora
																<br />

															<h4>SMS Prayer Network</h4>
															Dini Groenewold
															<ul className="no-list-style">
																<li>0400 019 473</li>
																<li>
																	<a href="mailto:rmdjgroenewold@gmail.com">rmdjgroenewold@gmail.com</a>
																</li>
															</ul>
														</div>
														<div className="col-md-4 col-sm-6 col-xs-12">
															<h4>Pathway Care / Deacons</h4>
															John and Diane de Jonge
															<ul className="no-list-style">
																<li>0418 501 298</li>
																<li>0438 366 582</li>
																<li>
																	<a href="mailto:johndidj@outlook.com ">johndidj@outlook.com</a>
																</li>
															</ul>
															<h4>Pathway Operations</h4>
															Mark de Jonge
															<ul className="no-list-style">
																<li>0419 151 880</li>
																<li>
																	<a href="mailto:markjessdejonge@gmail.com">markjessdejonge@gmail.com</a>
																</li>
															</ul>
															<h4>Music Ministry</h4>
															Team Contact: Bianca Niebuur
															<ul className="no-list-style">
																<li>0408 319 931</li>
																<li>
																	<a href="mailto:rnbniebuur@gmail.com">rnbniebuur@gmail.com</a>
																</li>
															</ul>
														</div>
														<div className="col-md-4 col-sm-6 col-xs-12">
															<h4>Secretary</h4>
															Laura Cowen
															<ul className="no-list-style">
																<li>0417 877 698</li>
																<li>
																	<a href="mailto:lauraj5cowen@gmail.com">lauraj5cowen@gmail.com</a>
																</li>
															</ul>
															<h4>Treasurer</h4>
															Jody Kirwood
															<ul className="no-list-style">
																<li>0438 972 272</li>
																<li>
																	<a href="mailto:jodyanion@gmail.com">jodyanion@gmail.com</a>
																</li>
															</ul>
															<h4>Administrator</h4>
															Jessica de Jonge
															<ul className="no-list-style">
																<li>0467 376 767</li>
																<li>
																	<a href="mailto:markjessdejonge@gmail.com">markjessdejonge@gmail.com</a>
																</li>
															</ul>
															<h4>Church Library</h4>
															Carla Vos
															{/* <ul className="no-list-style">
																<li></li>
															</ul> */}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

export default Directory;
